import useStore from "../../../store"
import { useState } from "react"
import { MdCancel } from "react-icons/md"
import { useTranslation } from "react-i18next"
import { colors } from "../../../utilities/colors"

export default function UploadUnitFile() {
  const [imagePreview, setImagePreview] = useState(null)
  const setUploadingBos = useStore((state) => state.setUploadingBos)
  const bosFile = useStore((state) => state.bosFile)
  const setBosFile = useStore((state) => state.setBosFile)
  const { t } = useTranslation()

  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    setBosFile(file)

    const reader = new FileReader()
    reader.onloadend = () => {
      setImagePreview(reader.result)
    }
    if (file) {
      reader.readAsDataURL(file)
      setUploadingBos(true)
    }
  }

  const handleRemoveFile = () => {
    setBosFile(null)
    setImagePreview(false)
    setUploadingBos(false)
  }

  return(
    <div className="mt-2 flex items-center h-24">
      {!bosFile &&
        <label className="relative bg-gray-300 rounded-md cursor-pointer">
          <span className="py-2 px-4 inline-block rounded border-2 border-grey-700 mb-4 w-32" data-testid="choose-file">{t('Choose File')}</span>
          <input
            type="file"
            className="sr-only"
            onChange={handleFileUpload}
            accept=".jpg, .jpeg, .png, .HEIC, .pdf"
          />
        </label>
      }
      {bosFile &&
        <div className="relative mt-2 w-24 h-24">
          <img
            src={imagePreview}
            alt="Preview"
            data-testid="bos-preview"
            className="w-full h-full object-cover border border-gray-300 rounded"
          />
          <MdCancel
            onClick={handleRemoveFile}
            className="absolute top-0 right-0 w-5 h-5"
            color={colors.fpxRed}
            data-testid="md-cancel"
          />
        </div>
      }
    </div>
  )
}